import React, { memo } from "react";

import DriverPendingBalances from "./DriverPendingBalances";

const DriverPendingBalancesTab = ({
  driverPendingBalanceArray,
  i18n,
  renderNoResultsFound,
  closeModal
}) => {

  return (
    <div>
      {driverPendingBalanceArray
        ? <DriverPendingBalances
            driverPendingBalanceArray={driverPendingBalanceArray}
            i18n={i18n}
            closeModal={closeModal}
          />
        : renderNoResultsFound()}
    </div>
  );
};

export default memo(DriverPendingBalancesTab);
